import React from 'react';
import { Card, Empty, Spin } from 'antd';
import { useSelector } from 'react-redux';
import { Grid } from '@mui/material';
import Graph from './Graph';
import AnswerStatisticsGraph from './AnswerStatisticsGraph';
import { ReactComponent as FireIcon } from "./../../Icons/fire.svg";


export default function Statistics() {
	const userState = useSelector((state) => state.user);
	const myStatState = useSelector((state) => state.myStatsData);

	const texttualStyles = {
		fontSize: '11px',
		lineHeight: '20px',
		display: 'flex',
		justifyContent: 'space-between',
		fontFamily:'Inter'
	}

	const headingColor = {
		color:'rgb(42, 54, 74)'
	}
	return (
		<>
			<Grid container xs={12} lg={12} xl={12} sm={12} md={12} columnGap={2} paddingTop={0} spacing={1} >
				<Grid item xs={12} sm={12} md={12} lg={4} xl={4}>
					<Card title="Ranking" style={{textAlign:'center'}} styles={{header:headingColor,body:{color:'rgb(42, 54, 74)',fontFamily:'inter',maxHeight:'270px',overflowY:'scroll'}}}>
						{
							myStatState.isLoading === false && myStatState.expertRankData && myStatState.expertRankData.expertScores !== null && myStatState.expertRankData.expertScores && myStatState.expertRankData.expertScores.length > 0 && myStatState.expertRankData.expertScores.map((data, ind) => {
								return (
									<>
										<div key={ind} style={texttualStyles} >
											<h4 style={{ fontSize: data.user.userUuidStr === userState.geoAttributes.userId ? "18px" : "16px", fontWeight: data.user.userUuidStr === userState.geoAttributes.userId ? "bold" : 300 }} >
												{data.rank}
											</h4>
											<h4 style={{ fontSize: data.user.userUuidStr === userState.geoAttributes.userId ? "18px" : "16px", fontWeight: data.user.userUuidStr === userState.geoAttributes.userId ? "bold" : 300 }} >
												{data.user.firstName}&nbsp;{data.user.lastName}
											</h4>
											<h4 style={{fontSize: data.user.userUuidStr === userState.geoAttributes.userId ? "18px" : "16px", fontWeight: data.user.userUuidStr === userState.geoAttributes.userId ? "bold" : 300 }}>
												{data.score === undefined ? 0.00 : data.score}
											</h4>
										</div>
									</>
								)
							})
						}
						{myStatState.isLoading === false && myStatState.expertRankData.expertScores  === undefined && <Empty />}
						{myStatState.isLoading && <Spin spinning={true} size="large" style={{display:'flex',justifyContent:'center'}} />}
					</Card>
				</Grid>
				<Grid item xs={12} sm={12} md={12} lg={4} xl={4}>
					<Card title="KPIs" style={{textAlign:'center'}} styles={{header:headingColor,body:{color:'rgb(42, 54, 74)',fontFamily:'inter'}}}>
						<div style={{ display: 'flex', justifyContent: 'space-between' }}>
							<h4 style={{ fontSize: '14px', fontWeight: 300 }}>
								Total Answered Questions
							</h4>
							<h4 style={{ fontSize: '14px', fontWeight: 500 }}>
								{myStatState.viewCountData.totalAnswered && myStatState.viewCountData.totalAnswered.toLocaleString()}
							</h4>
						</div>
						<div style={{ display: 'flex', justifyContent: 'space-between' }}>
							<h4 style={{ fontSize: '14px', fontWeight: 300 }}>
								Express Questions Answered
							</h4>
							<div style={{ display: "flex" }}>
									<FireIcon style={{marginRight:'2px',height:'16px'}} />
								<h4 style={{ fontSize: '14px', fontWeight: 500 }}>
									{userState.expressQuestionsAnswered && userState.expressQuestionsAnswered > 0 ? userState.expressQuestionsAnswered : "0"}
								</h4>
							</div>
						</div>
						<div style={{ display: 'flex', justifyContent: 'space-between' }}>
							<h4 style={{ fontSize: '14px', fontWeight: 300 }}>
								SLA Compliance
							</h4>
							<h4 style={{ fontSize: '14px', fontWeight: 500 }}>
								{myStatState.slaComplianceData.slaCompliancePercentage !== undefined ? Math.round(myStatState.slaComplianceData.slaCompliancePercentage) : 0}{" "}
								| 10
							</h4>
						</div>
						<div style={{ display: 'flex', justifyContent: 'space-between' }}>
							<h4 style={{ fontSize: '14px', fontWeight: 300 }}>
								Quality Score
							</h4>
							<h4 style={{ fontSize: '14px', fontWeight: 500 }}>
								{myStatState.expertScore?.score !== undefined
									? Math.round(myStatState.expertScore.score)
									: 0} | 10							</h4>
						</div>
						<div style={{ display: 'flex', justifyContent: 'space-between' }}>
							<h4 style={{ fontSize: '14px', fontWeight: 300 }}>
								Average Response Time
							</h4>
							<div style={{ display: "flex" }}>
								<h4 style={{ fontSize: "16px" }}>
									{ myStatState.avgResTime?.avgRespTime !== undefined ? Math.round(myStatState.avgResTime.avgRespTime) : 0}
								</h4>
								<h3 style={{ color: "#aaa", fontSize: "16px" }}>&nbsp;mins</h3>
							</div>
						</div>
					</Card>
				</Grid>
				<Grid item xs={12} sm={12} md={12} lg={3.5} xl={3.5}>
					<Card title='Answers View Count' style={{textAlign:'center'}} styles={{header:headingColor,body:{color:'rgb(42, 54, 74)',fontFamily:'inter'}}}>
						<div style={{ display: 'flex', justifyContent: 'space-between' }}>
							<h4 style={{ fontSize: '14px', fontWeight: 300 }}>Total Views of Answers</h4>
							<h4 style={{ fontSize: '14px', fontWeight: 500 }}>{myStatState.viewCountData.totalViewed && myStatState.viewCountData.totalViewed.toLocaleString()}</h4>
						</div>
						<div style={{ display: 'flex', justifyContent: 'space-between' }}>
							<h4 style={{ fontSize: '14px', fontWeight: 300 }}>Views of Express Answers</h4>
							<h4 style={{ fontSize: '14px', fontWeight: 500 }}>
								<FireIcon style={{marginRight:'2px',height:'16px'}} />
									{myStatState.viewCountData.expressViewed}</h4>
						</div>
						<div style={{ display: 'flex', justifyContent: 'space-between' }}>
							<h4 style={{ fontSize: '14px', fontWeight: 300 }}>Most Viewed Answer Count</h4>
							<h4 style={{ fontSize: '14px', fontWeight: 500 }}>
								{myStatState.viewCountData.highesetViewed && myStatState.viewCountData.highesetViewed.toLocaleString()}
							</h4>
						</div>
					</Card>
				</Grid>
			</Grid>
			<div style={{display:'flex',justifyContent:'center',fontSize: '21px',
    color:'rgb(42, 54, 74)',marginTop:'5px',marginBottom:'5px'}}>Expert Answers View Statistics</div>
		<Grid container lg={12} xl={12} sm={12} md={12} xs={12} spacing={2}>
						{myStatState.isLoading === false && <Graph />}
		</Grid>
		<div style={{display:'flex',justifyContent:'center',fontSize: '21px',
    color:'rgb(42, 54, 74)',marginTop:'5px',marginBottom:'5px'}}>Answer Statistics Breakdown</div>
		<Grid container xs={12} sm={12} md={12} lg={12} xl={12} spacing={2}>
			<AnswerStatisticsGraph />
		</Grid>
		</>
	)
}